import { useState } from "react";
import MShipmentItems from "./MShipmentItems/MShipmentItems";
import MShipments from "./MShipments/MShipments";

export default function EfsLayout() {
  /* ******************** All States ************************* */
  const [activeTab, setActiveTab] = useState("shipment");

  /* ******************** All Functions ************************* */
  const tabs = [
    { id: "shipment", label: " Import Shipments", icon: "mdi-truck-delivery" },
    {
      id: "shipmentItems",
      label: "Imported Items",
      icon: "mdi-package-variant",
    },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "shipment":
        return (
          <div className="">
            <MShipments />
          </div>
        );
      case "shipmentItems":
        return (
          <div className="">
            <MShipmentItems />
          </div>
        );

      default:
        return null;
    }
  };

  /* ******************** All UseEffects ************************* */

  return (
    <div className="" style={{ marginLeft: 260, height: "100vh" }}>
      {/* Tab Buttons */}
      <div className="card mb-3">
        <div className="card-body py-2">
          <div className="d-flex gap-0 justify-content-start flex-wrap">
            <div className="btn-group">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`btn ${
                    activeTab === tab.id ? "btn-primary" : "btn-outline-primary"
                  }`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <i className={`mdi ${tab.icon} me-1`}></i>
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content px-2">{renderTabContent()}</div>
    </div>
  );
}
